import { Box, IconButton, Image, useDisclosure } from "@chakra-ui/react";
import { useDeleteImageFromAppointment } from "api/appointments";
import Alert from "generics/Alert";
import { checkImage } from "helpers";
import React from "react";
import { RiDeleteBin6Line } from "react-icons/ri";

interface IFilePreviewProps {
  file: any;
  appointment: any;
  patient: any;
  test?: any;
  openImagePreview: (x: string) => void;
  size?: number;
  showDelete: boolean;
}

export function FilePreview({
  file,
  appointment,
  patient,
  test,
  openImagePreview,
  size,
  showDelete,
}: IFilePreviewProps) {
  const [deleteItem, deleteItemInfo] = useDeleteImageFromAppointment(test);

  const deleteModal = useDisclosure();

  return (
    <Box position="relative">
      <Alert
        confirmText="Delete"
        isOpen={deleteModal.isOpen}
        isLoading={deleteItemInfo.isLoading}
        onOk={() => deleteItem({ file, appointment, patient, test })}
        title="Delete Image"
        message={"Are you sure you want to delete this image?"}
        onClose={deleteModal.onClose}
      />
      <Image
        boxSize={size || 150 + "px"}
        borderRadius="md"
        bg="gray.700"
        objectFit="cover"
        cursor={checkImage(file.name) ? "pointer" : "inherit"}
        src={file.url}
        onClick={() => openImagePreview(file)}
        fallbackSrc={`https://via.placeholder.com/150/?text=${file.name
          .split(".")[1]
          .toUpperCase()}`}
      />
      {showDelete && (
        <IconButton
          p={0}
          // color="red.300"
          position="absolute"
          top="0"
          right="0"
          size="xs"
          opacity="0.7"
          // variant="ghost"
          onClick={deleteModal.onOpen}
          aria-label="delete photo"
          icon={<RiDeleteBin6Line />}
          isLoading={deleteItemInfo.isLoading}
        />
      )}
    </Box>
  );
}

interface LocalFilePreviewProps {
  file: any;
  image: any;
  setImage: (x: any) => void;
  size?: number;
  index?: number;
}

export function LocalFilePreview({
  file,
  setImage,
  size,
  image,
  index,
}: LocalFilePreviewProps) {
  const deleteModal = useDisclosure();

  function deleteFile() {
    const remaining = image.filter((img: any, i: number) => i !== index);
    setImage(remaining);
    deleteModal.onClose();
  }

  return (
    <Box position="relative">
      <Alert
        confirmText="Delete"
        isOpen={deleteModal.isOpen}
        onOk={() => deleteFile()}
        title="Delete Image"
        message={"Are you sure you want to delete this image?"}
        onClose={deleteModal.onClose}
        isLoading={false}
      />
      <Image
        boxSize={size || 150 + "px"}
        borderRadius="md"
        bg="gray.700"
        objectFit="cover"
        src={file.url}
        fallbackSrc={`https://via.placeholder.com/150/?text=${file.img.name
          .split(".")[1]
          .toUpperCase()}`}
      />
      <IconButton
        p={0}
        position="absolute"
        top="0"
        right="0"
        size="xs"
        opacity="0.7"
        onClick={deleteModal.onOpen}
        aria-label="delete photo"
        icon={<RiDeleteBin6Line />}
      />
    </Box>
  );
}
